import { render, staticRenderFns } from "./BlockStatusAutomation.vue?vue&type=template&id=2bd76e5f&"
import script from "./BlockStatusAutomation.vue?vue&type=script&lang=js&"
export * from "./BlockStatusAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports